import React, { useEffect, useState } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Btn, ContainerIncidence, Total } from './styled.components';
import { getIncidencias } from 'actions/portalClientes';
import { Button, IconButton } from '@mui/material';
import LoopIcon from '@mui/icons-material/Loop';
import { hotToast } from 'utils';




ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top' as const,
    },
    title: {
      display: true,
      text: 'Incidencias',
    },
  },
};

const labels = ['Liberación de productos', 'Falta de productos', 'Actitud inapropiada en PDV', 'Problemas con venta', 'Transferencia de productos', 'Materiales de degustación', 'Uniformes', 'Codigos (SKU)', 'Otros']






const Incidencias = () => {
  const [data, setData] = useState([]);

  const [items, setItems] = useState([]);
  const [counts, setCounts] = useState([]);

  useEffect(() => {
    if (data.length === 0) {
      getAll();
    }
  }, [])

  const getAll = async () => {
    let response = await getIncidencias();

    if(response === null){ return  hotToast("No hay información que mostrar", "WAR"); }


    let flag = false
    if (data.length !== 0) {
      response.map((first:any)=>{
        const a: any | null = data.find((second:any)=> first.incidence === second.incidence);
        if(a){
          if(a.noIncidents !== first.noIncidents){
            flag = true;
          }
        }
      })

      if (!flag) {
        return hotToast("No hubo cambios en la información", "WAR");
      }

    }





    let LItem: any = [];
    let LCounts: any = [];
    response.map((data: any) => {
      LItem.push(data.incidence);
      LCounts.push(data.noIncidents)
    })
    setItems(LItem);
    setCounts(LCounts);
    setData(response);
  }
  const getInfo = () => {
    return {
      labels: items,
      datasets: [
        {
          label: 'Incidencias',
          data: counts,
          backgroundColor: '#F09999',
        }
      ],
    };
  }




  return (
    <ContainerIncidence>
      <Btn sx={{alignSelf:"flex-start"}} variant="contained" onClick={getAll} disableRipple endIcon={<LoopIcon />}>
        Actualizar
      </Btn>

      <Bar options={options} data={getInfo()} />


      <Total>
        <span children="Total de incidencias" />
        <span className='numero' children={counts.reduce((partialSum, a) => partialSum + a, 0)} />
      </Total>
    </ContainerIncidence>
  );
}

export default Incidencias